import { render, staticRenderFns } from "./TextArray.vue?vue&type=template&id=e0a219a8&scoped=true&"
import script from "./TextArray.vue?vue&type=script&lang=js&"
export * from "./TextArray.vue?vue&type=script&lang=js&"
import style0 from "./TextArray.vue?vue&type=style&index=0&id=e0a219a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0a219a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/c/Users/wbreu/Documents/code/personal/the-unit-planner/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('e0a219a8', component.options)
    } else {
      api.reload('e0a219a8', component.options)
    }
    module.hot.accept("./TextArray.vue?vue&type=template&id=e0a219a8&scoped=true&", function () {
      api.rerender('e0a219a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TextArray.vue"
export default component.exports